const US_REGION = 'US';

const resolveRegion = (locale: string | undefined): string | undefined => {
    if (!locale) {
        return;
    }
    try {
        // Intl.Locale normalizes casing and shorthand, so 'en-us' resolves the same as 'en-US'.
        return new Intl.Locale(locale).region;
    } catch {
        return;
    }
};

const browserLocale = (): string | undefined => (typeof navigator === 'undefined' ? undefined : navigator.language);

export const prefersUsConventions = (locale: string | undefined = browserLocale()): boolean => {
    const region = resolveRegion(locale);
    return region === undefined || region === US_REGION;
};

export type MeasurementSystem = 'us' | 'eu';

export const defaultMeasurementSystem = (locale?: string): MeasurementSystem =>
    prefersUsConventions(locale) ? 'us' : 'eu';
